"use client";

import React from "react";

const ActionButtons: React.FC = () => {
  const openLink = (url: string): void => {
    window.open(url, "_blank");
  };

  // Responsive button size classes:
  // Mobile: 50x50, Desktop (md+): 60x60
  const buttonSizeClasses = "w-[50px] h-[50px] md:w-[60px] md:h-[60px]";

  // Common button styles
  const buttonBaseStyles =
    `${buttonSizeClasses} cursor-pointer rounded-[28px] text-center leading-[60px] md:leading-[60px] flex items-center justify-center text-2xl z-50 text-white`;

  return (
    <div className="fixed right-4 md:right-6 bottom-[110px] md:bottom-[130px] z-50 flex flex-col items-end space-y-4">
      <div
        onClick={() => openLink("https://wa.me/4402080792721")}
        className={`${buttonBaseStyles} bg-green-500`}
        title="WhatsApp"
      >
        <i className="ri-whatsapp-line"></i>
      </div>
      <div
        onClick={() => openLink("mailto:info@uvercee.co.uk")}
        className={`${buttonBaseStyles} bg-[#ea4335]`}
        title="Email"
      >
        <i className="ri-mail-line"></i>
      </div>
      <div
        onClick={() => openLink("https://www.instagram.com/uvercee/")}
        className={`${buttonBaseStyles} instagram-gradient`}
        title="Instagram"
      >
        <i className="ri-instagram-line"></i>
      </div>
    </div>
  );
};

export default ActionButtons;
